import { useEffect } from 'react';

/**
 * Injects a <meta name="robots" content="noindex, nofollow"> tag into <head>
 * while the component is mounted. Removes it on unmount so other pages remain indexable.
 */
const NoIndex = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow, noarchive, nosnippet';
    document.head.appendChild(meta);
    const prevTitle = document.title;
    return () => {
      document.head.removeChild(meta);
      document.title = prevTitle;
    };
  }, []);
  return null;
};

export default NoIndex;
